export default __webpack_public_path__ + "static/media/list.02a96b5b.svg";